import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { CreateEventDTO, EventsApiService, eventsQueryKeys } from 'features/events';
import { queryClient } from 'providers';


const { updateParticipant } = EventsApiService();

export const useUpdateParticipant = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: CreateEventDTO) => {
      return updateParticipant(payload as any);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: eventsQueryKeys.all,
        });
        message.success("Participate Details has been updated successfully!!");
      },
    },
  );
};
